import PropTypes from "prop-types";
import React from "react";
import { FLSA_REPORT_COLUMNS } from "./columns";
import { FLSA_REPORT_STRINGS } from "./strings";
import Table from "reactstrap/lib/Table";
import SortHeaderWithSeparateKeysComponent from "components/common/SortHeader/SeparateKeys";

const { MESSAGES } = FLSA_REPORT_STRINGS;

const FLSAReportTableComponent = (props, context) => {
  const {
    router: {
      route: {
        match: {},
      },
    },
  } = context;
  const {
    data,
    location: { query },
    pageSize,
  } = props;
  const { page = 1 } = query;

  return (
    <div className="ml-3 mr-4">
      <Table
        hover
        responsive
        size="sm"
        className="table-overtime-report align-table right-align-table right-align-col align-firstcol"
      >
        <thead className="Header-col">
          <tr>
            {FLSA_REPORT_COLUMNS.map((col) =>
              col.sortable ? (
                <SortHeaderWithSeparateKeysComponent
                  key={col.key}
                  field={col.key}
                  orderingKey={col.orderingKey}
                  orderingValueMap={col.orderingValueMap}
                >
                  {col.label}
                </SortHeaderWithSeparateKeysComponent>
              ) : (
                <th key={col.key}>{col.label}</th>
              ),
            )}
          </tr>
        </thead>

        <tbody>
          {data
            .filter(
              (item, index) =>
                index < page * pageSize && index >= (page - 1) * pageSize,
            )
            .map((item) => (
              <tr key={item.index}>
                <td className="pl-3">{item.first_name}</td>
                <td>{item.last_name}</td>
                <td>{item.employee_id}</td>
                <td>{item.week_start_date}</td>
                <td>{item.week_end_date}</td>
                <td className="text-right">{item.qualified_ot}</td>
                <td className="text-right pr-3">{item.qualified_dt}</td>
                <td className="text-right pr-3">{item.total_qualified}</td>
              </tr>
            ))}

          {!data.length && Object.keys(query).length > 0 && (
            <tr>
              <td colSpan="7" className="text-center">
                {MESSAGES.NO_RECORDS_FOUND}
              </td>
            </tr>
          )}

          {!data.length && Object.keys(query).length === 0 && (
            <tr>
              <td colSpan="7" className="text-center">
                {MESSAGES.SEARCH_ABOVE_FOR_RESULTS}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

FLSAReportTableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
};

FLSAReportTableComponent.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default FLSAReportTableComponent;
